import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { PaletteType, ResponsiveService, SizeType, WeightType } from '@cf/core';

@Component({
  selector: 'cf-text',
  template: `
    <span
      [style.font-style]="fontStyle"
      class="text text-size--{{ size }} text-color--{{ color }} text-weight--{{ weight }} {{
        className ? className : ''
      }} text-{{ textTransform }} text-decoration-{{ textDecoration }}"
    >
      <ng-content></ng-content>
    </span>
  `,
  styleUrls: ['./text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextComponent implements OnInit {
  @Input() className: string | null = null;

  @Input() size: SizeType = 'md';

  @Input() touchSize!: SizeType;

  @Input() color: PaletteType = 'grey-80';

  @Input() weight: WeightType = '400';

  @Input() fontStyle: 'normal' | 'italic' = 'normal';

  @Input() textTransform!: 'lowercase' | 'uppercase' | 'capitalize';

  @Input() textDecoration!: 'line-through' | 'none' | 'underline';

  constructor(
    private readonly responsiveService: ResponsiveService,
    private readonly cd: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    const initialSize = this.size;

    if (this.touchSize) {
      this.responsiveService.isTouch$.subscribe((isTouchScreen) => {
        if (isTouchScreen) {
          this.size = this.touchSize;
        } else {
          this.size = initialSize;
        }

        this.cd.detectChanges();
      });
    }
  }
}
